import { render, staticRenderFns } from "./CartDumps.vue?vue&type=template&id=b4bdbde0&"
import script from "./CartDumps.vue?vue&type=script&lang=js&"
export * from "./CartDumps.vue?vue&type=script&lang=js&"
import style0 from "./CartDumps.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports